require('./bootstrap');

require('./general');

require('./agents/users');
require('./agents/permissions/role');
require('./agents/permissions/role');
require('./agents/permissions/permissions');
require('./agents/permissions/role_has_permissions');
require('./agents/routes');
//require('./agents/orders');
require('./agents/ordersv2');
require('./agents/picking-area');
require('./global_alerts')
require('./agents/customers')
//require('./agents/picking-detail');
require('./agents/storage-areas');
require('./agents/assortment');

